import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { FormikProps } from 'formik';

import { InvestingGoalsForm } from 'common/forms';
import { InvestingGoalsFormValues } from 'common/models/Forms';

import { QuestionTitle, PageControls } from '../../../../components';
import {
  selectProtocolGoals,
  setProtocolGoalsValuesAction,
  selectInformationsCustomerInfo1,
  selectInvestingHazard,
} from '../../../../ducks';
import { useFormStepContinueRef } from '../../../../hooks/useFormStepContinueRef';
import { FeatureProps } from '../../../../index';

export default function ProtocolGoalsFeature({ isPrivileged }: FeatureProps) {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const initialValues = useSelector(selectProtocolGoals);
  const customerValues = useSelector(selectInformationsCustomerInfo1);
  const hazardValues = useSelector(selectInvestingHazard);

  const { bindFormik, continueWithSoftValidation, showSoftContinueHint } =
    useFormStepContinueRef<InvestingGoalsFormValues>();

  function handleBackClick() {
    navigate(-1);
  }

  async function handleContinueClick() {
    await continueWithSoftValidation((values) => {
      handleSubmit(values);
    });
  }

  function bindSubmit(formik: FormikProps<InvestingGoalsFormValues>) {
    bindFormik(formik);
  }

  function handleSubmit(values: InvestingGoalsFormValues) {
    if (!isPrivileged) {
      dispatch(setProtocolGoalsValuesAction(values));
    }
    navigate(`/form/${id}/protocol/initiation`);
  }

  return (
    <>
      <QuestionTitle>{t('protocolFeature.goals')}</QuestionTitle>
      <InvestingGoalsForm
        hazard={hazardValues || undefined}
        initialValues={{
          ...initialValues,
          a: customerValues!.goal,
        }}
        bindSubmit={bindSubmit}
        onSubmit={handleSubmit}
      />
      <PageControls softContinueHint={showSoftContinueHint} onBack={handleBackClick} onContinue={handleContinueClick} />
    </>
  );
}
